import { commonrequest } from "./ApiCall";
import { BACKEND_URL } from "./Helper";

export const registerfunction = async(data) => {
    return await commonrequest("POST",`${BACKEND_URL}/nearbe/shopregister`,data)
}

export const sendotpfunction = async(data) => {
    return await commonrequest("POST",`${BACKEND_URL}/nearbe/sendotp`,data)
}

export const loginfunction = async(data) => {
    return await commonrequest("POST",`${BACKEND_URL}/nearbe/login`,data)
}